<template lang="pug">
    div.d-inline-block
        div.from
            v-menu(
                ref="menuFrom"
                v-model="menuFrom"
                :close-on-content-click="false"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                max-width="290px"
            )
                template(v-slot:activator="{ on }")
                    div.moreWrapper(v-on="on")
                        div.content
                            div.name {{ $t('fields.dateFrom') }}
                            div.date.dateFrom {{ dateFrom | formattedDate }}
                        div.icon
                            v-icon.moreIcon expand_more

                v-date-picker(
                    v-model="dateFrom"
                    :max="startDateMax"
                    scrollable
                    no-title
                    color="primary"
                )
                    div.controls
                        button-component(
                            :action="rangeSubmit"
                            color="primary"
                            flat
                            small
                        ) {{ $t('defaultButtons.ok') }}
        div.to
            v-menu(
                ref="menuTo"
                v-model="menuTo"
                :close-on-content-click="false"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                max-width="290px"
            )
                template(v-slot:activator="{ on }")
                    div.moreWrapper(v-on="on")
                        div.content
                            div.name {{ $t('fields.dateTo') }}
                            div.date.dateFrom {{ dateTo | formattedDate }}
                        div.icon
                            v-icon.moreIcon expand_more

                v-date-picker(
                    v-model="dateTo"
                    :min="dateFrom"
                    :max="currentDay"
                    scrollable
                    no-title
                    color="primary"
                )
                    div.controls
                        button-component(
                            :action="rangeSubmit"
                            color="primary"
                            flat
                            small
                        ) {{ $t('defaultButtons.ok') }}
</template>

<script>
    import VueTypes from 'vue-types';
    import Button from '../Button';
    import formattedDate from '~filters/FormattedDate';
    import { mapGetters } from 'vuex';
    import dayjs from 'dayjs';

    export default {
        components: {
            ButtonComponent: Button
        },
        filters: {
            formattedDate
        },
        props: {
            id: VueTypes.string.def(''),
            rangeCallback: VueTypes.func.def(() => {})
        },
        data() {
            return {
                dateFrom: null,
                dateTo: null,
                menuFrom: false,
                menuTo: false,
                currentDay: dayjs().format('YYYY-MM-DD')
            };
        },
        computed: {
            ...mapGetters('statistics', ['period']),
            startDateMax() {
                if (
                    this.dateTo &&
                    dayjs(this.dateTo).isBefore(dayjs(this.currentDay))
                ) {
                    return this.dateTo;
                }

                return this.currentDay;
            }
        },
        watch: {
            period(newVal, oldVal) {
                if (oldVal === 'range' && newVal !== 'range') {
                    this.dateFrom = null;
                    this.dateTo = null;
                }
            }
        },
        methods: {
            rangeSubmit() {
                if (this.dateFrom && this.dateTo) {
                    this.rangeCallback({
                        from: dayjs(this.dateFrom),
                        to: dayjs(this.dateTo)
                    });
                }

                this.menuFrom = false;
                this.menuTo = false;
            }
        }
    };
</script>

<style lang="stylus" scoped>
    @import "../../assets/style/_mixins.styl"
    @import "../../assets/style/_variables.styl";

    .from
    .to
        display: inline-block;

    .from
        margin-right: 20px

    .moreWrapper
        display: flex
        cursor: pointer
        width: 115px

    .to .moreWrapper
        width: 108px

    .content
        padding-right: 15px

    .moreIcon
        background-color: $theme.white;
        border-radius: 50%
        font-size: 22px
        color: $theme.action

    .name
        font-weight: 700
        font-size: 16px

    .date
        font-size: remify(14px)

    .controls
        width: 100%
        text-align: right

    >>>a
        &.v-list__tile--link
            &:hover,
            & > .isActive
                background: transparent !important
                color: $theme.action

    @media screen and (max-width: $grid-breakpoints.sm - 1)
        .name
            font-size: 12px
            font-weight: normal

        .moreIcon
            font-size: 18px

        .content
            padding-right: 5px

        .from
            margin-right: 5px

        .moreWrapper
            width: 90px
        .to .moreWrapper
            width: 80px

        .date
            font-size: 11px
</style>
